import * as Flashphoner from '@flashphoner/websdk';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';

import * as FPUtils from '../modules/fp-utils';
import { Publisher } from './types';

const STREAM_STATUS = Flashphoner.constants.STREAM_STATUS;

export const VIDEO_CONTAINER_ID = 'viewerVideo';

interface ViewerPlayerProps {
  publisher?: Publisher;
  started: boolean;
  onEnded: (name: string) => void;
}

const ViewerPlayer = ({ publisher, started, onEnded }: ViewerPlayerProps) => {
  const playingRef = useRef<any>(null);

  const stopCurrent = () => {
    const stream = playingRef.current;
    playingRef.current = null;
    if (stream) {
      try {
        stream.stop();
      } catch (error) {
        //
      }
    }
  };

  const playStream = (target: Publisher) => {
    const container = document.getElementById(VIDEO_CONTAINER_ID);
    const streams = target.participant.getStreams();
    if (!container || streams.length === 0) return;
    const stream = streams[0];
    // Remove Cached Stream
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }
    playingRef.current = stream;
    stream
      .play(container)
      .on(STREAM_STATUS.PLAYING, (playingStream: any) => {
        if (playingRef.current !== stream) return;
        const video = document.getElementById(playingStream.id()) as HTMLVideoElement | null;
        if (video) {
          video.muted = false;
          video.addEventListener('resize', (event: any) => {
            FPUtils.resizeVideo(event.target);
          });
        }
      })
      .on(STREAM_STATUS.STOPPED, () => {
        if (playingRef.current !== stream) return;
        playingRef.current = null;
        onEnded(target.name);
      })
      .on(STREAM_STATUS.FAILED, () => {
        if (playingRef.current !== stream) return;
        playingRef.current = null;
        onEnded(target.name);
      });
  };

  useEffect(() => {
    if (started && publisher !== undefined) {
      playStream(publisher);
    }
    return () => {
      stopCurrent();
    };
  }, [started, publisher?.name, publisher?.streamId]);

  return (
    <PlayerTemplate>
      <VideoWrap>
        <div id={VIDEO_CONTAINER_ID}></div>
      </VideoWrap>
    </PlayerTemplate>
  );
};

const PlayerTemplate = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;
const VideoWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
`;

export default ViewerPlayer;
